export const Directoriess=[
    {
        "text":"www.facebook.com",
        "text1":"Start 20-02-2022  End 25-02-2022"
    },
    {
        "text":"www.instagram.com",
        "text1":"Start 20-02-2022  End 25-02-2022"
    },
    {
        "text":"www.samplewebsonly.com",
        "text1":"Start 20-02-2022  End 25-02-2022"
    },
    {
        "text":"www.mpollo.io",
        "text1":"Start 20-02-2022  End 25-02-2022"
    },
    {
        "text":"www.imovies.com.cn",
        "text1":"Start 20-02-2022  End 25-02-2022"
    },
    {
        "text":"www.p123sit.com",
        "text1":"Start 20-02-2022  End 25-02-2022"
    },
    {
        "text":"Facebook.com",
        "text1":"Start 20-02-2022  End 25-02-2022"
    },

]
export const Tablearay=[
    {
        "num":"#00019298812",
        "mail":"www.123Directories.com",
        "data":"02/09/2022",
        "dname":"by Adam Person",
        "business":"Cube Adx",
        "add":"Added - 02/09/2022",
        "expire":"Expire - 02/09/2023",
        "street":"106 Douers",
        "state":"106 Douers",
        "city":"Miami",
        "zip":"32226",
        "number":"+1490300330"


    },
    {
        "num":"#00019298812",
        "mail":"www.123Directories.com",
        "data":"02/09/2022",
        "dname":"by Adam Person",
        "business":"Cube Adx",
        "add":"Added - 02/09/2022",
        "expire":"Expire - 02/09/2023",
        "street":"106 Douers",
        "state":"106 Douers",
        "city":"Miami",
        "zip":"32226",
        "number":"+1490300330"


    },
    {
        "num":"#00019298812",
        "mail":"www.123Directories.com",
        "data":"02/09/2022",
        "dname":"by Adam Person",
        "business":"Cube Adx",
        "add":"Added - 02/09/2022",
        "expire":"Expire - 02/09/2023",
        "street":"106 Douers",
        "state":"106 Douers",
        "city":"Miami",
        "zip":"32226",
        "number":"+1490300330"


    },
    {
        "num":"#00019298812",
        "mail":"www.123Directories.com",
        "data":"02/09/2022",
        "dname":"by Adam Person",
        "business":"Cube Adx",
        "add":"Added - 02/09/2022",
        "expire":"Expire - 02/09/2023",
        "street":"106 Douers",
        "state":"106 Douers",
        "city":"Miami",
        "zip":"32226",
        "number":"+1490300330"


    },
    {
        "num":"#00019298812",
        "mail":"www.123Directories.com",
        "data":"02/09/2022",
        "dname":"by Adam Person",
        "business":"Cube Adx",
        "add":"Added - 02/09/2022",
        "expire":"Expire - 02/09/2023",
        "street":"106 Douers",
        "state":"106 Douers",
        "city":"Miami",
        "zip":"32226",
        "number":"+1490300330"


    },
]
export const Daysarray=[
    {
        "day":"Mon"
    },{
        "day":"Tue"
    },
    {
        "day":"Wed"
    },
    {
        "day":"Thu"
    },
    {
        "day":"Fri"
    },
    {
        "day":"Sat"
    },
]